import isTouchDevice from './isTouchDevice';

export default isTouchDevice;
